import { useEffect, useState } from 'react'

/**
 * Custom hook to detect user preference for reduced motion.
 * Uses `window.matchMedia` to check the `prefers-reduced-motion` media query.
 */
export function usePrefersReducedMotion(): boolean {
  const [prefersReducedMotion, setPrefersReducedMotion] = useState(() => {
    if (
      typeof window !== 'undefined' &&
      typeof window.matchMedia === 'function'
    ) {
      return Boolean(
        window.matchMedia('(prefers-reduced-motion: reduce)').matches
      )
    }
    return false // Default to false if matchMedia is not available
  })

  useEffect(() => {
    if (
      typeof window === 'undefined' ||
      typeof window.matchMedia !== 'function'
    ) {
      return
    }

    const mediaQuery = window.matchMedia('(prefers-reduced-motion: reduce)')

    // Safari before 14 and partial matchMedia stubs have no addEventListener. The initial value still applies.
    if (typeof mediaQuery?.addEventListener !== 'function') {
      return
    }

    const handleChange = () => {
      setPrefersReducedMotion(mediaQuery.matches)
    }

    mediaQuery.addEventListener('change', handleChange)

    return () => {
      mediaQuery.removeEventListener('change', handleChange)
    }
  }, [])

  return prefersReducedMotion
}
